import "babel-polyfill";
import React from "react";
import { createRoot } from "react-dom/client";

export default function mount(Component, context = {}, documentId = "root") {
    Object.assign(window.initial.context, context);

    const container = document.getElementById(documentId);
    const root = createRoot(container);
    root.render(<Component {...window.initial} />);
}
